/**
 * programLimit 课程学习限制
 * @author 3173
 * @date 2020-01-21
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer } = framework_tool;
let { WizCol, WizRow, WizCheckbox, WizSelect, WizIcon, WizTooltip, WizModal ,WizButton } = component_tool;
import { Input, Row, Col } from 'antd'
import '../../../../styles/containers/online/programDetail/index.less'

import { WizTableForm,WizPreCondition as PreCondition } from '../../../common'
//import PreCondition from '../../preCondition/preCondition'
import cloneDeep from 'lodash/cloneDeep'

const examConfig = WizTableForm.Config.exam(this, { apiParams: { status: 1 } })
const programConfig = WizTableForm.Config.program(this, { apiParams: { status: 1 } })

const Option = WizSelect.Option;
const pml = 20; //间距

class ProgramLimit extends WizContainer {

  componentName = 'ProgramLimit';

  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,

  };

  constructor(props) {
    super(props);
    let _p = cloneDeep(props.value)
    this.state = {
      //value: _p.value ? _p.value : undefined,
      showLimit: _p && _p.preConditionId && _p.preConditionId!=-1 ? true : false,
      limit: _p && _p.preConditionId ? [0] : undefined,

      preCondition: _p && _p.preCondition? Object.assign({},_p.preCondition):undefined,//前置条件

      limitOrder: _p && _p.limitOrder ? _p.limitOrder : 0,//学习顺序限制
    };
    this.currentData = {};//当前选择的单个前置条件
  }

  _componentWillMount() {
    this.onChange()
  }

  _componentWillReceiveProps(nextProps) {

  }

  propsAndStateOnChange = {
    value: this.onReset.bind(this),

  }

  onReset(nextProps,nextState){
    if (this.props.value !== nextProps.value) {
      let _p =  cloneDeep(nextProps.value)
      if(_p!=undefined){
        nextState.showLimit=(_p && _p.preConditionId && _p.preConditionId!=-1 && _p.preCondition) || _p.showLimit ? true : false //|| this.state.showLimit
        nextState.limit= _p && _p.preConditionId  ? [0] : undefined
        nextState.limitOrder= _p && _p.limitOrder ? _p.limitOrder : 0
        nextState.preCondition= _p && _p.preCondition? _p.preCondition:undefined
        nextState.date = new Date().getTime()
      }
    }
    this.props.onChange(nextState)
    return true;
  }


  /**
   * 将值反馈给Form
   */
  onChange = (key, changeValue) => {
    const { onChange } = this.props;
    let _value = {
      limitOrder: this.state.limitOrder,
      preCondition: this.state.preCondition,
      preConditionId: this.props.value && this.props.value.preConditionId ? this.props.value.preConditionId : undefined,
      showLimit: this.state.showLimit
    };

    if(key){
      _value[key] = changeValue
      this.setState({
        [key]: changeValue,
        date: new Date().getTime()
      }, () => {
        onChange && onChange(_value);
      });
    }else{
      this.setState({
        date: new Date().getTime()
      }, () => {
        onChange && onChange(_value);
      });
    }

  };

  /**限制学习顺序值变化 */
  limitOrderChange = (value) => {
    let limitOrder = 0;
    if (value && value.length > 0) {
      limitOrder = 1;
    }
    this.onChange('limitOrder', limitOrder);
  }


  /**显示条件内容 */
  showLimit(checkedValues) {
    if (checkedValues.length > 0) {this.onChange('showLimit',true)
      //this.setState({ showLimit: true ,limit:[0] })
    } else {
      this.setState({ showLimit: false , limit: undefined , preCondition:undefined }, ()=>this.onChange())
      //去除前置条件

    }
  }

  /**显示条件 */
  showCondition(type, checkedValues) {
    if (checkedValues.length > 0) {
      this.setState({ [type]: true })
    } else {
      this.setState({ [type]: false })
    }
  }


  /**打开对应选择模态框 */
  openModal(openName,currentData){
    this.setState({[openName]:true})
    this.currentData = currentData;
  }


  /**前置条件数据修改 */
  changePreCondition(preCondition){
    let neoPreCondition = Object.assign({},preCondition) ;
    this.setState({preCondition:neoPreCondition},()=>{ this.onChange()});

  }

  //['program','exam','path','survey']
  _render() {
    const { placeholder, ...otherProps } = this.props;
    return (
      <>
        {/*<Row>*/}
        {/*  <Col>*/}
        {/*    <WizCheckbox.Group key={'limit'} options={[{ label: '限制课程学习', value: 0 }]} value={this.state.showLimit ? [0] : null} onChange={(checkedValues) => this.showLimit(checkedValues)} />*/}
        {/*    <WizTooltip title="完成设置的前置条件才允许进行课程学习">*/}
        {/*      <WizIcon type="question-circle-o" />*/}
        {/*    </WizTooltip>*/}
        {/*  </Col>*/}
        {/*</Row>*/}
        {
         // this.state.showLimit ?
         //  <PreCondition key={'programLimit'+new Date().getTime()} display={this.state.showLimit} key='preCondition' value={this.state.preCondition} showRows={['program','exam','survey']} onChange={this.changePreCondition.bind(this)}/>
         //   : null
        }

        <Row>
          <Col span={10}>
            <WizCheckbox.Group key={'limitOrder'} options={[{ label: '限制课程内容学习顺序', value: 1 }]} value={[this.state.limitOrder]} onChange={(checkedValues) => this.limitOrderChange(checkedValues)} />
            <WizTooltip title="限制学员必须100%完成上一个课件，才能学习下一个课件，不可跳过">
                <WizIcon type="question-circle-o" />
            </WizTooltip>
          </Col>
          {/* <Col span={14}> <WizIcon type="question-circle" /><span style={{ fontSize: 10, color: '#6E7B8B', marginLeft: 4 }}>限制学员必须100%完成上一个课件，才能学习下一个课件，不可跳过</span></Col> */}
        </Row>

      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

export default connect(mapStateToProps)(ProgramLimit);
